var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('button',{staticClass:"theme-toggle-btn",on:{"click":_vm.toggleTheme}},[(_vm.isDark)?_c('Sun',{attrs:{"size":20}}):_vm._e(),_vm._v(" "),(!_vm.isDark)?_c('MoonStar',{attrs:{"size":20}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }